.newsletter-list-item {
    padding-bottom: 32px;
    border-bottom: 1px solid var(--off-white-dk);
}

.edition-list {
    display: flex;
    padding-top: 8px;
}
